import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Necesito saber de Registros Akáshicos para usar esto?',
    a: 'No. Cada tomo está diseñado para personas sin experiencia previa. Todo está explicado paso a paso con lenguaje claro y directo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Una vez confirmado el pago recibís el acceso inmediato por mail con el link de descarga. En menos de 5 minutos tenés todo en tu dispositivo.'
  }, {
    q: '¿Qué lo diferencia de un libro de autoayuda?',
    a: 'Los libros de autoayuda te dan inspiración. Este sistema te da protocolos específicos paso a paso. No es información, es implementación directa.'
  }, {
    q: '¿Sirve si ya hice terapia o trabajo espiritual antes?',
    a: 'Sí. El método trabaja una capa que la terapia convencional generalmente no alcanza: el campo akáshico y energético. Complementa y profundiza cualquier proceso anterior.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas. Si no es lo que esperabas, te devolvemos el 100%.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-69">
      <div className="text-center mb-12" data-id="element-70">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[24px]" data-id="element-71">
          <span className="mr-3" data-id="element-72">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-73">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-text/10" data-id="element-74">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-75">
              <span className="font-medium pr-8 text-[16px]" data-id="element-76">{faq.q}</span>
              <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-77" />
            </button>
            <AnimatePresence data-id="element-78">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-79">
                  <div className="px-6 pb-5 text-brand-text/70 border-t border-brand-text/10 pt-4 text-[14px]" data-id="element-80">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};